import axios from 'axios';

import config from 'config';

import { getRequestId } from './create-request-id';
import { errorInterceptor } from './helpers';

const {
  bff: { applicationID, baseUrl, clientID },
} = config;

export const apiGRecaptcha = axios.create({
  baseURL: baseUrl,
  headers: {
    Application: applicationID,
    client_id: clientID,
    'Content-Type': 'application/json',
    'session-id': getRequestId(),
  },
});

apiGRecaptcha.interceptors.response.use((response) => response, errorInterceptor);
